import { DsfrErrorField } from "./dsfr-error-field";
export class RequiredFields {

    static hasError = false;

    static checkAllRequiredFieldsOnChange() {

        $("#g6k_form .fr-input , #g6k_form .fr-select").on("blur", function (e) {
            RequiredFields._checkInputAndSelect($(this));
        });

        $("#g6k_form input[type=radio], #g6k_form input[type=checkbox]").on("change", function () {
            RequiredFields._checkInputCheckboxAndRadio($(this));
        });

    }

    static checkAllRequiredFieldsOnSubmit() {

        $("#g6k_form .fr-input , #g6k_form .fr-select").each(function (index) {
            RequiredFields._checkInputAndSelect($(this));
        });

        $("#g6k_form input[type=radio], #g6k_form input[type=checkbox]").each(function (index) {
            RequiredFields._checkInputCheckboxAndRadio($(this));
        });

    }

    static _checkInputAndSelect($this) {

        if (!$this.prop('required')) {
            return;
        }

        let inputLabel = $this.prev("label").data("label");
        let inputName = $this.attr('name');

        //verifie si le champ n'est pas deja en erreur, pour ne pas écraser ou supprimer ce message d'erreur.
        if (DsfrErrorField.onError(inputName)) {
            return;
        }

        try {
            if ($this.val() == "") {
                let fieldMsgError = Translator.trans("The '%field%' field is required", { "field": inputLabel });
                DsfrErrorField.setMsgError(inputName, fieldMsgError)
            } else {
                DsfrErrorField.removeMsgError($this.attr('name'));
            }
        } catch (e) {
            console.log("Echec message requis sur:" + $this.attr('name'));
        }

    }

    static _checkInputCheckboxAndRadio($this) {

        let $fieldset = $this.closest('fieldset'); 

        if (!$fieldset.data('required')) {
            return;
        }

        let id = $fieldset.attr('id');
        let checked = false;
        let message = $fieldset.find("legend").data("label");
        let fieldMsgError="";

        //verifie si le champ n'est pas deja en erreur, pour ne pas écraser ou supprimer ce message d'erreur.
        if (DsfrErrorField.onError(id)) {
            return;
        }
     
        try {

            $fieldset.find("input[type=checkbox],input[type=radio]").each(function (index) {
                if (this.checked) {
                    checked = true;
                }
            });

            if (!checked) {
                fieldMsgError = Translator.trans("The '%field%' field is required", { "field": message }, 'messages');
            } 
            DsfrErrorField.msgOnFieldset($fieldset,fieldMsgError);

        } catch (e) {
            console.log("Echec message requis sur champs:" + id);
        }

    }





}
